import { Injectable } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ConfirmationDialogInputComponent, ValueValidatorFn } from '../components';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogInputService {

  constructor(protected dialogService: DialogService) { }

  open(
    title: string,
    content: string,
    defaultValue?: string | null,
    isValueAcceptable?: ValueValidatorFn,
    maxLength?: number | null
  ): Observable<object> {
    const resultSubject = new Subject<object>();

    const dialogRef = this.dialogService.open({
      content: ConfirmationDialogInputComponent,
      title: title,
      cssClass: 'isg-dialog-editor isg-dialog-top',
      preventAction: (ev: any, dialog) => {
        if (ev && ev.value) {
          const formGroup = (dialog?.content.instance as ConfirmationDialogInputComponent).formGroup;
          if (!formGroup.valid) {
            formGroup.get('content')?.markAsTouched();
          }
          return !formGroup.valid;
        }
        return false;
      }
    });

    const componentRef = dialogRef.content;
    const confirmationInfo = componentRef.instance as ConfirmationDialogInputComponent;

    componentRef.setInput('title', title);
    componentRef.setInput('content', content);
    componentRef.setInput('defaultValue', defaultValue ?? '');
    componentRef.setInput('isValueAcceptable', isValueAcceptable);
    componentRef.setInput('maxLength', maxLength);
    outputToObservable(confirmationInfo.valueEntered).pipe(take(1)).subscribe((result: any) => {
      resultSubject.next(result);
      resultSubject.complete();
    });

    dialogRef.result.pipe(take(1)).subscribe(() => {
      if (!resultSubject.closed) {

        resultSubject.next({
          success: false
        });

        resultSubject.complete();
      }
    });

    return resultSubject.asObservable();
  }
}
